import React from 'react';
import { get } from 'lodash';
import { useAtomValue } from 'jotai';
import { useSelector, useDispatch } from 'react-redux';
import { summaryWidgetsSelector } from '@store/summaryWidgets/selector';
import { summaryPanelAtom } from '@src/atoms/panels';
import { SUMMARY_PANEL_TYPE } from './constants';
import SPIWidgetPanel from './spi-panel';
import NetworkPanel from './app-network-panel';
import ErrorBoundary from '@components/common/ErrorBoundary';
import { isAppSPIEnabledSelector } from '@store/common/selectors';
import { isAppModule } from '@utils/constants';
import { multiDimensionDrilldown } from '@store/trends/base/actions';
import { setDrillDown } from '@store/networkRequest/actions';
import { compareOnTrendsModeSelector } from '@store/trends/base/selectors';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { getUseCaseLimitation } from '@src/components/common/Dashboard/UseCases/limitation';

const renderWidgetPanelComponent = (type, condition, dispatch, usecaseKey) => {
  const disableSPI = get(
    getUseCaseLimitation(usecaseKey),
    ['summaryMetricPanel', 'SPIWidget', 'disabled'],
    false,
  );
  switch (type) {
    case SUMMARY_PANEL_TYPE.SPI:
      return condition[SUMMARY_PANEL_TYPE.SPI] && !disableSPI ? <SPIWidgetPanel /> : null;
    case SUMMARY_PANEL_TYPE.NETWORK:
      return condition[SUMMARY_PANEL_TYPE.NETWORK] ? (
        <NetworkPanel
          onSelect={(payload) => {
            dispatch(multiDimensionDrilldown(payload));
            dispatch(setDrillDown(true));
          }}
          onResetCallback={() => dispatch(setDrillDown(false))}
        />
      ) : null;
    default:
      return null;
  }
};

const WidgetPanelContainer = () => {
  const isAppSPIEnabled = useSelector(isAppSPIEnabledSelector);
  const summaryWidgets = useSelector(summaryWidgetsSelector);
  const showPanel = useAtomValue(summaryPanelAtom);
  const dispatch = useDispatch();

  // hide summary panel on compare mode
  const compareMode = useSelector(compareOnTrendsModeSelector);

  // hide summary panel under eco event preset dashboard.
  const { usecaseKey } = useSelector(activeDashboardSelector);
  const renderCondition = {
    [SUMMARY_PANEL_TYPE.SPI]: isAppModule && !isAppSPIEnabled ? false : true,
    [SUMMARY_PANEL_TYPE.NETWORK]: true,
  };

  return showPanel && !compareMode ? (
    <ErrorBoundary>
      {renderWidgetPanelComponent(summaryWidgets.type, renderCondition, dispatch, usecaseKey)}
    </ErrorBoundary>
  ) : null;
};

export default WidgetPanelContainer;
